export enum Table {
  Countries = "countries",
  Invites = "invites",
  ItineraryInvites = "itinerary_invites",
  Itineraries = "itineraries",
  Members = "members",
  Teams = "teams",
  Travelers = "travelers",
  Accounts = "accounts",
  DataSources = "datasources",
  EmbedUsers = "embed_users",
  APIKeys = "api_keys",
  Widgets = "widgets",
  Dashboards = "dashboards",
  DashboardDatasources = "dashboard_datasources",
  Sessions = "sessions",
  Questions = "questions",
  Integrations = "integrations",
  IntegrationTables = "integration_tables",

  DecryptedIntegrations = "decrypted_integrations",
  DecryptedSessions = "decrypted_sessions",
  DecryptedWidgets = "decrypted_widgets",
  DecryptedDatasources = "decrypted_datasources",
  Subscriptions = "subscriptions",
  SubscriptionPlans = "subscription_plans",

  Automations = "automations",
  AutomationRuns = "automation_runs",

  Logs = "logs",
  Messages = "messages",
}
